import React from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import EventGroupsPicker from '@/components/EventGroupsPicker';

const IncludeHeadersOption = props => {
	const {
		widgetToUpdate,
		handleChange,
		widgetProps,
		onUpdate,
		event,
		handleGroupChange,
		targetKeys,
	} = props;

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<Form.Item label="Include Widget Headers?" name="include_headers">
					<Form.TwoOptionSelect />
				</Form.Item>
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
		</Form>
	);
};

export default IncludeHeadersOption;
